import SelectEventGroupAndPaymentMethodFormContainer from './SelectEventGroupAndPaymentMethodFormContainer';

export default SelectEventGroupAndPaymentMethodFormContainer;
